import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { Announcement } from '../types';
import dayjs from 'dayjs';

export const useColumns = () => {
  const { t } = useTranslation(TranslationsKeys.ANNOUNCEMENTS_LIST);

  const columns = useMemo<ColumnTable<Announcement>[]>(
    () => [
      {
        headerText: t(`table.title`),
        tdClassName: 'text-center fw-700',
        thClassName: 'text-center',
        columnName: 'title',
        width: 190,
      },
      {
        headerText: t(`table.school`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'school',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.academicLevel`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'academicLevel',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.studyPlan`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'studyPlan',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.publishAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'publishAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
      {
        headerText: t(`table.validUntilAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'validUntilAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
    ],
    [t],
  );
  return columns;
};
